import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-italic-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="currentColor"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M16.5866 6.5H10.4133C10.1399 6.5 9.91992 6.27333 9.91992 6C9.91992 5.72667 10.1466 5.5 10.4199 5.5H16.5866C16.8599 5.5 17.0866 5.72667 17.0866 6C17.0866 6.27333 16.8599 6.5 16.5866 6.5Z" />
      <path
        d="M13.5864 18.5H7.41309C7.13975 18.5 6.91309 18.2733 6.91309 18C6.91309 17.7267 7.13975 17.5 7.41309 17.5H13.5798C13.8531 17.5 14.0798 17.7267 14.0798 18C14.0798 18.2733 13.8598 18.5 13.5864 18.5Z" />
      <path
        d="M10.5004 18.5004C10.4604 18.5004 10.4204 18.4937 10.3804 18.4871C10.1137 18.4204 9.94706 18.1471 10.0137 17.8804L13.0137 5.88039C13.0804 5.61372 13.3471 5.44706 13.6204 5.51372C13.8871 5.58039 14.0537 5.85372 13.9871 6.12039L10.9871 18.1204C10.9271 18.3471 10.7271 18.5004 10.5004 18.5004Z" />
    </svg>
  `,
})
export class ItalicIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
